"use strict";
/**
 * @module Services.RemoveTopic
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveTopic = void 0;
/**
 * Data type for a TOPIC_REMOVAL request.
 */
var RemoveTopic = /** @class */ (function () {
    /**
     * Create a new RemoveTopic instance
     *
     * @param selector  the topic selector to remove
     */
    function RemoveTopic(selector) {
        this.selector = selector;
    }
    return RemoveTopic;
}());
exports.RemoveTopic = RemoveTopic;
